function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "className", "required", "requiredLabel", "requiredProps", "showLabel", "size", "weight"],
  _excluded2 = ["showLabel", "size", "weight"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import { FontSizes, FontWeights } from "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import { getFontSize, getFontWeight } from "../../../../styles/styled-components/font.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import { screenReaderOnly } from "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseLabel } from "../base-label/base-label.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardLabel = function BaseStandardLabel(props) {
  var _classnames;
  var children = props.children,
    className = props.className,
    required = props.required,
    requiredLabel = props.requiredLabel,
    requiredProps = props.requiredProps,
    showLabel = props.showLabel,
    size = props.size,
    weight = props.weight,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isRequired = required && requiredLabel;
  return /*#__PURE__*/React.createElement(BaseLabel, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-label__standard': true,
      'bf-label__standard--hidden': !showLabel,
      'bf-label__standard--required': isRequired
    }, _defineProperty(_classnames, "bf-label__standard--size-".concat(size), !!size), _defineProperty(_classnames, "bf-label__standard--weight-".concat(weight), !!weight), _defineProperty(_classnames, "".concat(className), !!className), _classnames))
  }), children, isRequired && /*#__PURE__*/React.createElement("span", _extends({}, requiredProps, {
    "aria-label": requiredLabel,
    className: classnames(_defineProperty({
      'bf-label__standard-required': true
    }, "".concat(className), !!className)),
    role: "img"
  }), "*"));
};
var Label = styled(BaseStandardLabel)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  ", "\n  ", "\n  ", "\n\n  .bf-label__standard-required {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.darkMode ? BrandfolderHexColors.White : BrandfolderHexColors.Text;
}, function (_ref2) {
  var size = _ref2.size;
  return getFontSize({
    size: size
  });
}, function (_ref3) {
  var weight = _ref3.weight;
  return getFontWeight({
    weight: weight
  });
}, function (_ref4) {
  var showLabel = _ref4.showLabel;
  return showLabel ? '' : screenReaderOnly;
}, BrandfolderHexColors.WarningRed);
/**
 * A `<label>` for an element like `<input>` or `<textarea>`.
 * Proper usage includes wrapping form inputs inside of the `<label>`, or
 * linking them with the `htmlFor` attribute to the element `id` attribute.
 * All text needs to be translated by your app.
 *
 * The `children` of the `<label>` should be basic [phrasing content](https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#phrasing_content).
 * A `<label>` should not contain any `<a>` tags, `<h1>` through `<h6>` tags,
 * or `<button>` tags. A `<label>` should also not contain another nested `<label>`.
 *
 * Setting `required` to `true` will show an asterisk denoting that the corresponding form control is required.
 * Additionally, `aria-required="true"` needs to be set on the form control.
 * Optionally, you may also add instructions to your form, such as
 * `<StandardText>Fields marked with an asterisk (*) are required.</StandardText>`
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label
 *
 * https://dequeuniversity.com/tips/identify-required-elements
 *
 * @param props StandardLabelProps
 * @returns FunctionComponent<StandardLabelProps>
 */
var StandardLabel = function StandardLabel(props) {
  var _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    _props$size = props.size,
    size = _props$size === void 0 ? FontSizes.Small : _props$size,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? FontWeights.Medium : _props$weight,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Label, _extends({}, otherProps, {
    showLabel: showLabel,
    size: size,
    weight: weight
  })));
};
export { BaseStandardLabel, StandardLabel };